import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import type {RouteObject} from '@github-ui/react-router'

import {buildIssuesLayoutRoute} from './issues-layout-route'
import {IssuesLayout} from './IssuesLayout'
import {buildLabelsRoute} from './labels-route'
import {Labels} from './Labels'
import {labelsLegacyRedirectLoader} from './labels-legacy-redirect-loader'

// The loader always redirects, so nothing is ever shown here. But React Router still
// renders the matched route and warns if a leaf route has no Component. this
// fails the tests (vitest-fail-on-console), so we pass an empty component
const LabelsRedirectFallback = () => null

/**
 * Builds the Issues route objects for a given app builder.
 *
 * Route configs are bound to the app builder that creates them (embedded-data
 * hydration + query-key app name), so registering these routes under a different
 * app (e.g. `repo`) requires rebuilding them with that app's builder rather than
 * importing the `issues`-bound singletons directly.
 */
export function createIssuesRoutes(appBuilder: DataRouterApplicationBuilder<string>): RouteObject[] {
  return [
    buildIssuesLayoutRoute(appBuilder).toRoute({
      Component: IssuesLayout,
      children: [
        buildLabelsRoute(appBuilder).toRoute({Component: Labels}),
        // defining it as a plain object because its just a legacy-redirect path
        {path: '/:owner/:repo/issues/labels', loader: labelsLegacyRedirectLoader, Component: LabelsRedirectFallback},
      ],
    }),
  ]
}
